import React from "react";

// ===== Constants =====
const COMPANY_NAME = "Realm Digital";
const FOOTER_SLOGAN = "Imagine then build";
const COPYRIGHT_YEAR = 2025;
const COMPANY_LOGO_SRC = "/realmIcon.svg";
const COMPANY_LOGO_ALT = "Realm Digital Logo";

/**
 * Footer Component
 * - Displays footer at the bottom of the slideshow page
 * - Left side: slogan / tagline
 * - Right side: logo + copyright
 */
const Footer: React.FC = () => {
    return (
        <footer className=" w-full text-white py-4 px-20 flex flex-col md:flex-row justify-between items-center">

            {/* --- Left side: slogan --- */}
            <div className="text-left mb-4 md:mb-0">
                <p className="text-gray-300 text-sm">
                    {COMPANY_NAME} • {FOOTER_SLOGAN}
                </p>
            </div>

            {/* --- Right side: logo + copyright --- */}
            <div className="flex items-center gap-2 text-gray-300">
                <img src={COMPANY_LOGO_SRC} alt={COMPANY_LOGO_ALT} className="w-6 h-6" />
                <span>{COMPANY_NAME} © {COPYRIGHT_YEAR}</span>
            </div>
        </footer>
    );
};

export default Footer;


